// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__yarUI"};